module.exports = __webpack_public_path__ + "static/media/HQ-icon.e91c81ad.svg";